import React from 'react'
import styles from './styles.module.scss'
import { HiLightBulb } from 'react-icons/hi'

const ResultsTable = ({ data }) => {
  if (!data || data.length === 0) return null

  return (
    <div className={styles.tableSection}>
      <h3 className={styles.title}>Планируемые результаты освоения</h3>

      <table className={styles.resultsTable}>
        <thead>
          <tr>
            <th className={styles.resultsTableHeader}>Код и наименование</th>
            <th className={styles.resultsTableHeader}>Дисциплины, формирующие компетенции</th>
          </tr>
        </thead>
        <tbody>
          {data.map((category, catIndex) => (
            <React.Fragment key={catIndex}>
              <tr className={styles.categoryRow}>
                <td colSpan={2}>
                  <div className={styles.categoryCell}>
                    <i className={styles.categoryIcon}><HiLightBulb /></i>
                    <span>{category.cat_name}</span>
                  </div>
                </td>
              </tr>

              {category.tasks?.map((task, taskIndex) => {
                const disciplines = task.disciplines || []
                const isEmpty = disciplines.length === 0

                return (
                  <tr key={task.compet_code || taskIndex} className={styles.taskRow}>
                    <td className={`${styles.codeCell} ${isEmpty ? styles.errorCell : ''}`}>
                      {task.compet_name ? `${task.compet_code}. ${task.compet_name}` : task.compet_code}
                    </td>
                    <td className={`${styles.disciplinesCell} ${isEmpty ? styles.errorCell : ''}`}>
                      {isEmpty
                        ? '—'
                        : disciplines.map((discipline, idx) => (
                            <div key={idx} className={styles.discipline}>{discipline}</div>
                          ))}
                    </td>
                  </tr>
                )
              })}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ResultsTable
